import { render, staticRenderFns } from "./ManagementTab.vue?vue&type=template&id=e9b0086a&scoped=true&"
import script from "./ManagementTab.vue?vue&type=script&lang=js&"
export * from "./ManagementTab.vue?vue&type=script&lang=js&"
import style0 from "./ManagementTab.vue?vue&type=style&index=0&id=e9b0086a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b0086a",
  null
  
)

export default component.exports